export type Library = 'edls';

export interface DesignToken {
  css: string;
  type: 'font' | 'color' | 'index' | 'radius' | 'size' | 'space' | 'transition';
  category?: string;
  variant?: string;
  scale?: string;
  property?: string;
  modifier?: string;
  meta: Record<string, string | boolean | undefined>;
  value?: string | string[];
  library?: Library;
}

export interface ClassMeta {
  name: string;
  declarations: string[];
  prefixes: string[];
  layer: string;
  library?: Library;
}

declare const meta: {
  classNames: string[];
  classes: ClassMeta[];
  tokens: DesignToken[];
  customMedia: {
    name: string;
    value: string;
  }[];
};

export default meta;
